import React from 'react'
import styled from 'styled-components/macro'
import { injectIntl, FormattedMessage, intlShape } from '@dragonraider5/react-intl'
import { rem, mediaMaxWidth } from '../../../utils/styles'

import ArrowLink from '../../../components/ArrowLink'
import Footer from '../../../components/Footer'
import SocialNav, { SocialLink } from '../../../components/SocialNav'
import { Facebook, Instagram, Linkedin, Twitter, YouTube } from '../../../components/SocialIcon'
import messages from './messages'

export const socials = [
  { name: 'Facebook', Icon: Facebook, href: 'https://www.facebook.com/Triodos.es' },
  { name: 'Twitter', Icon: Twitter, href: 'https://twitter.com/triodoses' },
  { name: 'Instagram', Icon: Instagram, href: 'https://www.instagram.com/triodoses/?hl=es' },
  { name: 'Linkedin', Icon: Linkedin, href: 'https://www.linkedin.com/company/triodos-bank-espa-a/' },
  { name: 'Youtube', Icon: YouTube, href: 'https://www.youtube.com/user/triodosbankspain' }
]

export const AppSocialNav = styled(SocialNav)`
  margin: auto 0;
  @media (max-width: ${mediaMaxWidth('desktop')}) {
    margin-bottom: ${rem(16)};
    padding-left: ${rem(15)};
  }
`
export const AppLinksNav = styled('div')`
  display: grid;
  @media (max-width: ${mediaMaxWidth('desktop')}) {
    margin-bottom: ${rem(16)};
  }
`

export const ContactNav = AppLinksNav

// props -> socialProps -> <SocialLink />
export const renderSocialLinks = ({ intl }) => ({ name, Icon, ...props }) => (
  <SocialLink
    {...props}
    key={name}
    target='_blank'
    rel='noopener noreferrer'
    title={intl.formatMessage(messages.socialNavLinkTitle, { name })}
    inverted
  >
    <Icon />
  </SocialLink>
)

// message -> <ArrowLink />
export const renderPrivacyLink = message => (
  <ArrowLink
    href='https://www.triodos.es/es/politica-privacidad'
    title={message}
    target='_blank'
    rel='noopener noreferrer'
    inverted
  >
    {message}
  </ArrowLink>
)

// message -> <ArrowLink/>
export const renderLegalLink = message => (
  <ArrowLink
    href='https://triodos.es/es/aviso-legal'
    title={message}
    target='_blank'
    rel='noopener noreferrer'
    inverted
  >
    {message}
  </ArrowLink>
)

export const renderContact = message => (
  <ArrowLink
    key='Email'
    target='_blank'
    rel='noopener noreferrer'
    href='mailto:solicitudfinanciacion.digital@triodos.es'
    title='solicitudfinanciacion.digital@triodos.es'
    inverted
  >
    {message}
  </ArrowLink>
)

export function AppFooter({ intl }) {
  const { formatMessage } = intl

  return (
    <Footer>
      <AppSocialNav title={formatMessage(messages.socialNavTitle)}>
        {socials.map(renderSocialLinks({ intl }))}
      </AppSocialNav>
      <AppLinksNav>
        <FormattedMessage {...messages.privacyLink}>
          {renderPrivacyLink}
        </FormattedMessage>
        <FormattedMessage {...messages.legalLink}>
          {renderLegalLink}
        </FormattedMessage>
        {/* <FormattedMessage {...messages.contact}>
          {renderContact}
        </FormattedMessage> */}
      </AppLinksNav>
    </Footer>
  )
}

AppFooter.propTypes = {
  intl: intlShape.isRequired
}

export default injectIntl(AppFooter)
